import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../../services/user.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

export const agendaGuardGuard: CanActivateFn = async(route, state) => {
  
  const userService = inject(UserService);
  const router = inject(Router);

  try{

    const response = await firstValueFrom(userService.getConfigUser());

    if(!response.configUser.agendaMenu) throw new Error("Nao possui acesso ao menu de agendas!");
  
    return true;
  
  }catch(error: any){
    router.navigate(['app/disparos'])
    return false;
  }
};
